import React, { createContext, FC, useContext, useMemo } from 'react';

export const NodeExecutionErrorContext = createContext<{ message: string } | null>(null);

interface NodeExecutionErrorContextProviderProps {
    error?: string;
    children: React.ReactNode;
}

export const NodeExecutionErrorContextProvider: FC<NodeExecutionErrorContextProviderProps> = props => {
    const value = useMemo(() => (props.error !== undefined ? { message: props.error } : null), [props.error]);
    return <NodeExecutionErrorContext.Provider value={value}>{props.children}</NodeExecutionErrorContext.Provider>;
};

export function useNodeExecutionError() {
    return useContext(NodeExecutionErrorContext);
}
